import styled from 'styled-components';

export const ButtonText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default ButtonText;
